import { PipeTransform } from '@angular/core';
var DeadlineTimePipe = /** @class */ (function () {
    function DeadlineTimePipe() {
    }
    DeadlineTimePipe.prototype.transform = function (minutes) {
        if (minutes <= 0) {
            return '0min';
        }
        var days = Math.floor(minutes / (24 * 60));
        var remainingMinutes = minutes % (24 * 60);
        var hours = Math.floor(remainingMinutes / 60);
        var mins = remainingMinutes % 60;
        var parts = [];
        if (days > 0) {
            parts.push(days + "d");
        }
        if (hours > 0) {
            parts.push(hours + "h");
        }
        if (mins > 0) {
            parts.push(mins + "min");
        }
        return parts.join(' ');
    };
    return DeadlineTimePipe;
}());
export { DeadlineTimePipe };
